import { CURRENT_CLIENT } from '@/constants'

type DashboardSectionCopy = { capabilities?: string[]; comingSoon?: string[] }

/** Tenant `dashboardSections.<focus>` copy for the default focus dashboards. */
export function getDashboardSection(focus: string): DashboardSectionCopy | undefined {
  return (CURRENT_CLIENT as { dashboardSections?: Record<string, DashboardSectionCopy> })
    .dashboardSections?.[focus]
}

export function countLabel(count: number, singular: string, plural: string): string {
  return count === 1 ? singular : plural
}
